package one.healthium.domain.user

import co.touchlab.kermit.Logger
import one.healthium.base.preferences.AppPreferences
import one.healthium.domain.push.PushTokenInteractor
import one.primehealth.app.UserDataManager

class LogoutInteractor(
    private val userRepository: UserRepository,
    private val userDataManager: UserDataManager,
    private val appPreferences: AppPreferences,
    private val pushTokenInteractor: PushTokenInteractor,
) {
    suspend fun deleteAccount() {
        try {
            pushTokenInteractor.unregisterToken()
        } catch (e: Exception) {
            Logger.e("Failed to unregister push token before account deletion", e)
        }
        userRepository.deleteAccount()
        userRepository.logout()
        userDataManager.clear()
        appPreferences.clearUserPreferences()
    }

    suspend fun logout() {
        try {
            pushTokenInteractor.unregisterToken()
        } catch (e: Exception) {
            Logger.e("Failed to unregister push token on logout", e)
        }
        userRepository.logout()
        userDataManager.clear()
        appPreferences.clearUserPreferences()
    }
}
